import deburr from 'lodash/deburr';
import { FULL_NAME_PATTERN } from './consts';

interface DropdownValue {
  value: string;
  displayValue: string;
}

export const toDropDownValues = (
  obj: Record<string, string>
): DropdownValue[] =>
  Object.entries(obj).map(([, value]) => ({
    value,
    displayValue: value
  }));

/**
 * Validates a full name has no numbers or special characters (other than ones that are common in names)
 * @param fullName Name to be tested
 * @returns is full name valid
 */
export function validateFullName(fullName: string): boolean {
  const deburredValue = deburr(fullName);

  return FULL_NAME_PATTERN.test(deburredValue);
}
